import { useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { GET_TECH_HOURS_REPORT, GET_TECH_HOURS_ESTIMATE } from "../../graphql/queries/reports/techHoursReport.query";
import useDownloadCSV from "../other/useDownloadCSV.other.hook";

const CSV_HEADERS = [
  "Tech Name",
  "Start Time",
  "Customer Name",
  "Contact Name",
  "Ticket #",
  "Actual Time",
  "Billable Time",
  "Highest Billing",
  "Billable",
  "Notes",
  "Invoice #",
  "Invoice Total",
];

const useTechHoursReport = () => {
  const [rows, setRows] = useState([]);
  const handleDownload = useDownloadCSV();

  const [fetchEstimateQuery] = useLazyQuery(GET_TECH_HOURS_ESTIMATE, { fetchPolicy: "no-cache" });
  const [fetchReport, { loading, error }] = useLazyQuery(
    GET_TECH_HOURS_REPORT,
    { fetchPolicy: "no-cache" }
  );

  const getEstimate = async (startDate, endDate, billingStatuses = []) => {
    const res = await fetchEstimateQuery({
      variables: { start_date: startDate, end_date: endDate, billing_statuses: billingStatuses },
    });
    return res?.data?.techHoursEstimate || null;
  };

  const runReport = async (startDate, endDate, billingStatuses = []) => {
    const res = await fetchReport({
      variables: { start_date: startDate, end_date: endDate, billing_statuses: billingStatuses },
    });
    const data = res?.data?.techHoursReport || [];
    setRows(data);
    return data;
  };

  const downloadCSV = (data = rows, filename = "Tech Hours Report") => {
    handleDownload({
      headers: CSV_HEADERS,
      data: data.map((r) => [
        r.user || "",
        r.start_time ? new Date(r.start_time).toLocaleString("en-US") : "",
        (r.customer_name || "").replace(/,/g, " "),
        (r.contact_name || "").replace(/,/g, " "),
        r.ticket_number || "",
        r.actual_time || "",
        r.billable_time || "",
        r.top_biller_name ? `${r.top_biller_name} (${r.top_biller_time})` : "",
        r.billable ? "Yes" : "No",
        (r.notes || "").replace(/,/g, " "),
        r.invoice_number || "",
        r.invoice_total != null ? r.invoice_total : "",
      ]),
      filename,
    });
  };

  return { rows, runReport, getEstimate, downloadCSV, loading, error };
};

export default useTechHoursReport;
